'use client';

import dynamic from 'next/dynamic';
import { WarningCookieBannerWrapper } from './index';

export const DynamicWarningCookieBannerWrapper = dynamic<
  Parameters<typeof WarningCookieBannerWrapper>[0]
>(() => import('./index').then((mod) => mod.WarningCookieBannerWrapper), {
  ssr: false,
});
